import * as API from './index'

export default {
    get: params => {
        return API.GET('/api/News/Get', params)
    },
    getList: params => {
        return API.GET('/api/News/List', params)
    },
    getSingleByCategoryId: params => {
        return API.GET('/api/News/GetSingleByCategoryId', params)
    },
    select:params=>{
        return API.GET('/api/news/Select',params);
    }
}


// WEBPACK FOOTER //
// ./src/apis/news.js